import { render } from "./legoCheckbox.vue?vue&type=template&id=59171758"
import script from "./legoCheckbox.vue?vue&type=script&lang=js"
export * from "./legoCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoCheckbox/legoCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59171758"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59171758', __exports__)) {
    api.reload('59171758', __exports__)
  }
  
  module.hot.accept("./legoCheckbox.vue?vue&type=template&id=59171758", () => {
    api.rerender('59171758', render)
  })

}


export default __exports__